import { render, staticRenderFns } from "./TextWithLabel.vue?vue&type=template&id=49de022d&scoped=true&"
import script from "./TextWithLabel.vue?vue&type=script&setup=true&lang=js&"
export * from "./TextWithLabel.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49de022d",
  null
  
)

export default component.exports